import { DESCARGO_UNO_A_UNO, DescargaCommonGlobal } from "./descarga.global";
import { getMaterialHijoEnDescarga, getMaterialPadreEnDescarga } from "./common";
import { handleSiguienteMaterial } from "./descarga.recorrido";

/**
 * Del los pedimentos de importación disponibles, elimina los que se quedan en cero
 * en caso contrario actualiza la cantidad con el nuevo saldo
 * @param {Object} descargaResponse
 */
const handleDescargaResponseImportaciones = (descargaResponse) => {
    descargaResponse.forEach((descarga) => {
        const contenedorImpoId = descarga.contenedor_importacion;
        const index = DescargaCommonGlobal.contenedoresImportacionParaDescargar.findIndex(
            (itm) => itm.contenedor_id === contenedorImpoId,
        );

        if (descarga.restante > 0) {
            DescargaCommonGlobal.contenedoresImportacionParaDescargar[index].cantidad = descarga.restante;
        } else {
            const contenedoresParaDescargar = DescargaCommonGlobal.contenedoresImportacionParaDescargar.reduce(
                (previousValue, currentValue) => {
                    if (currentValue.contenedor_id !== contenedorImpoId) {
                        previousValue.push(currentValue);
                    }
                    return previousValue;
                },
                [],
            );

            DescargaCommonGlobal.contenedoresImportacionParaDescargar = contenedoresParaDescargar;
        }
    });
};

/**
 * De los pedimentos de exportación seleccionados para descarga, elimina el contenedor de
 * exportación descargado, si el pedimento se queda sin mercancias, eliminalo de la tabla
 * pedimento, si no existen más pedimentos por descargar, elimina el pedimento de la tabla
 * @param {number} cantidadExportacionPendientePorDescargar
 */
const handleDescargaResponseExportaciones = (cantidadExportacionPendientePorDescargar) => {
    const materialPadre = getMaterialPadreEnDescarga();
    if (DescargaCommonGlobal.enDescarga.tipo === DESCARGO_UNO_A_UNO) {
        materialPadre.cantidadPorDescargar = cantidadExportacionPendientePorDescargar;
    } else {
        const materialHijo = getMaterialHijoEnDescarga(materialPadre);
        materialHijo.cantidadPorDescargar = cantidadExportacionPendientePorDescargar;
    }
    handleSiguienteMaterial();
};

export const actualizarDataTables = (descargaResponse, cantidadExportacionPendientePorDescargar) => {
    handleDescargaResponseImportaciones(descargaResponse);
    handleDescargaResponseExportaciones(cantidadExportacionPendientePorDescargar);
};
